module.exports = __webpack_public_path__ + "img/tu3.0b83475f.png";